module.exports = __webpack_public_path__ + "media/images/flags/wf-db3ac768223218aaf9e422851641bdd7.svg";